<div class="transfer-out-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>Transfer Out Confirmation</h2>
  </div>

  <mat-dialog-content>
    <div class="warning-content">
      <div class="warning-icon">
        <span>i</span>
      </div>

      <h2>Transfer Out Confirmation</h2>

      <div class="field-group">
        <label>Game Provider</label>
        <div class="field-value">{{ gameProviderName }}</div>
      </div>

      <div class="field-group">
        <label>Game Wallet Balance</label>
        <div class="field-value">{{ gameWalletBalance | number:'1.2-2' }}</div>
      </div>

      <p class="warning-message">
        There are still balance in player's wallet, press <strong>Yes</strong> to transfer out before applying this promotion.
      </p>
    </div>
  </mat-dialog-content>

  <div class="dialog-actions">
    <button class="btn-no" (click)="onNo()" [disabled]="loading">
      No
    </button>
    <button class="btn-yes" (click)="onYes()" [disabled]="loading">
      <i *ngIf="loading" class="fas fa-circle-notch fa-spin mr-1"></i>
      Yes
    </button>
  </div>
</div>
